<script>
import Layout from '@layouts/auth'
import { authMethods } from '@state/helpers'
import getSecret from '@utils/get-secret'

export default {
  page: {
    title: 'Forget Password',
    meta: [{ name: 'description', content: `Forget Password to ${getSecret('TITLE')}` }],
  },
  components: { Layout },
  data() {
    return {
      email: '',
      error: null,
      tryingToReset: false,
      isResetError: false,
      isSuccess: false,
      successMessage: null
    }
  },
  computed: {
    getCompanyInfo: function () {
      return this.$store.state.appAuth.companyInfo || null
    },
  },
  methods: {
    ...authMethods,

    tryToReset() {
      this.tryingToReset = true
      // Reset the authError if it existed.
      this.error = null
      return this.forgotPasswordAction({
        email: this.email
      })
        .then((data) => {
          this.tryingToReset = false
          this.isResetError = false
          this.isSuccess = true
          this.successMessage = 'We have sent you an email with the instructions to reset your password.'
        })
        .catch((error) => {
          this.tryingToReset = false
          this.isResetError = true
          this.isSuccess = false
          this.error = "Internal Server Error"
        })
    },
  },
}
</script>

<template>
  <Layout>
    <div class="row justify-content-center">
      <div class="col-md-8 col-lg-6 col-xl-5">
        <div class="card bg-pattern">
          <div class="card-body pt-4 px-4 pb-2">
            <div class="text-center m-auto">
              <a href="/"> 
                <span>
                  <b-img
                    v-if="getCompanyInfo"
                    :src="getCompanyInfo.dark_logo || require('@assets/images/logos/logo-dark.png')"
                    alt="login"
                    fluid
                  />
                </span>
              </a>
              <p class="text-muted mb-4 mt-3">
                {{ $t('login_section.init_reset_password_msg') }}
              </p>
            </div>

            <b-alert v-if="error" v-model="isResetError" variant="danger" dismissible>
              {{error}}
            </b-alert>

            <b-alert v-model="isSuccess" variant="success" dismissible>
              {{ $t('login_section.email_sent_to_reset_password') }}
            </b-alert>

            <b-form @submit.prevent="tryToReset">
              <b-form-group
                id="email-group"
                :label="$t('email')"
                label-for="email"
              >
                <b-form-input
                  id="email"
                  v-model="email"
                  type="email"
                  required
                  :placeholder="$t('login_section.enter_email')"
                ></b-form-input>
              </b-form-group>

              <b-form-group id="button-group" class="mt-4">
                <b-button type="submit" variant="primary" class="btn-block" :disabled="tryingToReset">    
                  <span v-if="!tryingToReset">
                    {{ $t('login_section.reset_password') }} 
                  </span>
                  <b-spinner
                    v-if="tryingToReset"
                    small
                    label="Spinning"
                    variant="light"
                  >
                  </b-spinner>
                </b-button>
              </b-form-group>
            </b-form>
          <!-- end card-body -->
          </div>
        <!-- end card -->
        </div>
        <div class="col-12 text-center">
            <p>
              <router-link tag="a" to="/login" class="text-white-50 ml-1">
                {{ $t('login') }}
              </router-link>
            </p>
            
            <!-- <p class="text-white-50"
              >{{ $t('login_section.dont_have_an_account') }}
              <router-link tag="a" to="/register" class="text-white ml-1"><b>{{ $t('login_section.sign_up') }}</b></router-link>
            </p> -->
          </div>
      <!-- end col -->
      </div>
    <!-- end row -->
    </div>
    <!-- end row -->
  </Layout>
</template>

<style lang="scss" module></style>
